// frontend/src/components/ThemeToggle.js
import React from 'react';
import { Button } from 'react-bootstrap';
import { SunFill, MoonStarsFill } from 'react-bootstrap-icons';
import { useTheme } from '../contexts/ThemeContext';

function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant={theme === 'light' ? 'outline-dark' : 'outline-light'}
      onClick={toggleTheme}
      className={`rounded-circle p-2 d-flex align-items-center justify-content-center border-0 ${className}`}
      style={{ width: '40px', height: '40px', transition: 'all 0.3s ease' }}
      aria-label="Toggle dark mode"
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? <MoonStarsFill size={18} /> : <SunFill size={18} className="text-warning" />}
    </Button>
  );
}

export default ThemeToggle;
